export default "/assets/images/vendor/leaflet-extra-markers/dist/markers_shadow.png?151b708954e10ff9b542bc96d22ff0ff";